module.exports = __webpack_public_path__ + "051e870081761b6b315bd30fbff03752.svg";